module.exports = __webpack_public_path__ + "img/red_but.c35f527e.png";